// if (!process.env.REACT_APP_AUTHORITY || !process.env.REACT_APP_CLIENT_ID) {
//   throw 'Please configure AUTHORITY and CLIENT_ID in env.';
// }

export const AUTHORITY = process.env.REACT_APP_AUTHORITY;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
